export default {
  path: '/invitation/:invitation',
  name: 'Invitation',
  component: () => import(/* webpackChunkName: "invitation" */ '../../views/Invitation.vue'),
};
